;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"

import styles from "./styles.module.scss"
import Image from "next/image"
import topLeftChair from "./images/top-left.png"
import topMiddleChair from "./images/top-middle.png"
import topRightChair from "./images/top-right.png"
import bottomLeftChair from "./images/bottom-left.png"
import bottomRightChair from "./images/bottom-right.png"

function Chairs() {
  return (
    <div className={styles["container"]}>
      <div className={styles["top-row"]}>
        <div className={styles["top-left-chair"]}>
          <Image
            src={topLeftChair}
            alt="Support group chair"
            width={140}
            height={125}
          />
        </div>
        <div className={styles["top-middle-chair"]}>
          <Image
            src={topMiddleChair}
            alt="Group therapy chair"
            width={107}
            height={141}
          />
        </div>
        <div className={styles["top-right-chair"]}>
          <Image src={topRightChair} alt="Workshop chair" width={96} height={131} />
        </div>
      </div>
      <div className={styles["bottom-row"]}>
        <div className={styles["bottom-left-chair"]}>
          <Image
            src={bottomLeftChair}
            alt="Interpersonal processing chair"
            width={120}
            height={161}
          />
        </div>
        <div className={styles["bottom-right-chair"]}>
          <Image
            src={bottomRightChair}
            alt="Workshop skill building chair"
            width={120}
            height={167}
          />
        </div>
      </div>
    </div>
  )
}
export default Chairs
